export type Language = 'en' | 'fr';

export function getLanguage(): Language {
	const html = document.querySelector('html');
	if (html) {
		let lang = html.getAttribute('lang') as string;
		if (lang) {
			lang = lang.toLowerCase();
			if (lang.indexOf('fr') >= 0) {
				return 'fr';
			} else if (lang.indexOf('en') >= 0) {
				return 'en';
			}
		}
	}
	return 'en'; // by default
}
